import { z } from "zod";

export type Button = z.infer<typeof ButtonSchema>;
export const ButtonSchema = z.object({
  label: z.string(),
  payload: z.string(),
  type: z.string(),
  sns: z.string(),
  transactionCode: z.string(),
  color: z.string(),
  url: z.string(),
  serviceName: z.string(),
  path: z.string(),
});
